import axios from "axios";
import { API } from "@/lib/api";

const sellerApi = axios.create({ baseURL: API });

sellerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("ne_seller_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default sellerApi;
